import Link from 'next/link';
import React from 'react';
import { cn } from '@/utils/cn';
import Icon from '@/app/components/Icon';

function MainLogo({ isSearchActive = false, globalSearchModalActive }) {
  return (
    <Link
      prefetch={false}
      passHref
      href="/"
      className={cn(
        'pb-6 lg:pb-12',
        isSearchActive || (globalSearchModalActive && 'hidden lg:block'),
      )}
      aria-label="Singer Logo"
    >
      <Icon
        type="singer-logo"
        className="w-full min-w-[115px] lg:min-w-[172px]"
      />
    </Link>
  );
}

export default MainLogo;
